import { MAX_BUSINESS_DESCRIPTION_WORDS } from "../../../utils/textFieldValidation";
export default function BasicDetailsStep({ form, fieldErrors = {}, compact = false }) {
  const { renderField } = form;

  return (
    <div className={compact ? "row px-0" : "row px-2"}>
      {renderField("Business Name", "name", "text", 1, 12, "building", {
        fieldError: fieldErrors.name,
        required: true,
      })}
      {renderField("Tagline (Optional)", "tagline", "text", 1, 12, "chat-left-quote")}
      {renderField("Description (Optional)", "description", "text", 3, 12, "card-text", {
        fieldError: fieldErrors.description,
        maxWords: MAX_BUSINESS_DESCRIPTION_WORDS,
      })}
    </div>
  );
}
